import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoardSnowBr = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 208,
	height: 43,
	fill: "none",
	viewBox: "0 0 208 43",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M186.83 9.12c40.1 6.16 14.02 38.6-20.45 32.86l-42.07-7.01-36.34 7.01-72.34-7.01-11.66-9.03c-.59-3.55-8.63-1.8 0-10.66 10.78-11.08 30.86-3.02 38.5-6.16 33.38-13.7 45.5-10.52 74.83 0 6.47 2.33 14.3 0 20.9 6.16 5.28 4.92 14.67 2.05 18.7 0 5.95-2.05 20.36-7.63 29.93-6.16Z"
	})
});
export default SvgBoardSnowBr;
